var map = {
	"./BRELAG_MAGBattery": 25448,
	"./BRELAG_MAGBattery.vue": 25448,
	"./BRELAG_MAGContact": 13089,
	"./BRELAG_MAGContact.vue": 13089,
	"./BRELAG_MAGEvent": 51360,
	"./BRELAG_MAGEvent.vue": 51360,
	"./BRELAG_MAGLifesign": 83360,
	"./BRELAG_MAGLifesign.vue": 83360,
	"./BRELAG_Rocker": 61924,
	"./BRELAG_Rocker.vue": 61924,
	"./BRELAG_Save": 14464,
	"./BRELAG_Save.vue": 14464,
	"./BRELAG_Shutter": 59765,
	"./BRELAG_Shutter.vue": 59765,
	"./BRELAG_ShutterMoveAwning": 87867,
	"./BRELAG_ShutterMoveAwning.vue": 87867,
	"./BRELAG_ShutterMoveJalousie": 11991,
	"./BRELAG_ShutterMoveJalousie.vue": 11991,
	"./BRELAG_Status": 19880,
	"./BRELAG_Status.vue": 19880,
	"./IPSProfile": 37229,
	"./IPSProfile.vue": 37229,
	"./KNOCKAUT_Warning": 70291,
	"./KNOCKAUT_Warning.vue": 70291,
	"./LED_Switch": 45713,
	"./LED_Switch.vue": 45713,
	"./SONOS_Status": 24481,
	"./SONOS_Status.vue": 24481,
	"./Status_SONOS": 96856,
	"./Status_SONOS.vue": 96856,
	"./_HTMLBox": 79833,
	"./_HTMLBox.vue": 79833,
	"./_HexColor": 7994,
	"./_HexColor.vue": 7994,
	"./_Illumination": 711,
	"./_Illumination.vue": 711,
	"./_Intensity_": 94600,
	"./_Intensity_.vue": 94600,
	"./_Motion": 80734,
	"./_Motion.vue": 80734,
	"./_Raining": 2928,
	"./_Raining.vue": 2928,
	"./_WindSpeed_kmh": 86620,
	"./_WindSpeed_kmh.vue": 86620,
	"./datatypes/Datatype": 84675,
	"./datatypes/Datatype.vue": 84675,
	"./knockautX/ColourDataV2": 66196,
	"./knockautX/ColourDataV2.vue": 66196,
	"./knockautX/LEDTemperature": 91718,
	"./knockautX/LEDTemperature.vue": 91718,
	"./knockautX/PluginReceiverControl": 2200,
	"./knockautX/PluginReceiverControl.vue": 2200
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77869;